// keys
export const SHOPIFY_SANDBOX_BULK_CAMPAIGNS_ID =
  "shopifySandboxBulkCampaignsId";
export const SHOPIFY_AUTOCHECKOUT_TEMPLATE_WAS_REJECTED =
  "shopifyAutocheckoutTemplateWasRejected";
export const SHOPIFY_AUTOCHECKOUT_TEMPLATE_GOT_TIMEDOUT =
  "shopifyAutocheckoutTemplateGotTimeout";
